import React from 'react';
import PropTypes from 'prop-types';

import Dropdown from '../../../react-shared/Dropdown.jsx';
import Lightswitch from '../../../react-shared/Lightswitch.jsx';

import { dropdownItemPropType } from '../propTypes.js';

function Hero({
  activeCategories = [], categories, description = '', heading, setActiveCategories, setUseLocalTime, useLocalTime,
}) {
  const dropdownItems = [{ id: 'all', label: 'All Events' }, ...categories];

  const categoryChangeHandler = (id) => {
    if (id === 'all') {
      setActiveCategories([]);
    } else {
      setActiveCategories(activeCategories.includes(id)
        ? activeCategories.filter((cat) => ![id, 'all'].includes(cat))
        : [...activeCategories, id]);
    }
  };

  return (
    <section className="o-section">
      <div className="o-container">
        <div className="o-col o-col--10-at-small o-col--offset-1-at-small o-col--6-at-large o-col--offset-6-at-large o-col--7-at-xlarge o-col--offset-5-at-xlarge">
          <div className="o-col__inner c-event-schedule__hero">
            <div className="c-event-schedule__hero-intro">
              <h2 className="c-event-schedule__hero-heading c-hero-content__title">{heading}</h2>
              {description && <div className="c-hero-content__copy">{description}</div>}
            </div>

            <div className="c-event-schedule__hero-controls">
              <Dropdown
                changeHandler={categoryChangeHandler}
                id="category-selector"
                items={dropdownItems}
                selectedItems={activeCategories.length > 0 ? activeCategories : 'all'}
                withCheckboxes
              />

              <Lightswitch
                isToggledOn={!useLocalTime}
                textLeft="My Time"
                textRight="Track Time"
                toggleHandler={() => setUseLocalTime(!useLocalTime)}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

Hero.propTypes = {
  activeCategories: PropTypes.arrayOf(PropTypes.string),
  categories: PropTypes.arrayOf(dropdownItemPropType).isRequired,
  description: PropTypes.string,
  heading: PropTypes.string.isRequired,
  setActiveCategories: PropTypes.func.isRequired,
  setUseLocalTime: PropTypes.func.isRequired,
  useLocalTime: PropTypes.bool.isRequired,
};

export default Hero;
